export default [
    {
      imageset: [
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-1.jpg?updatedAt=1691465568113",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-2.jpg?updatedAt=1691465568520",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-3.jpg?updatedAt=1691465568172",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-4.jpg?updatedAt=1691465568233",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-5.jpg?updatedAt=1691465568716",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-6.jpg?updatedAt=1691465571593",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-7.jpg?updatedAt=1691465571749",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-8.jpg?updatedAt=1691465571820",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-9.jpg?updatedAt=1691465571858",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-10.jpg?updatedAt=1691465568334",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-11.jpg?updatedAt=1691465568345",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-12.jpg?updatedAt=1691465568141",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Table/Table%20Catalogue-13.jpg?updatedAt=1691465568078",
        },
      ],
      title: "Tablecloth, Runner, Placemat & Napkin",
    },
    {
      imageset: [            
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Kitchen/Kitchen%20Catalogue-1.jpg?updatedAt=1691465560463",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Kitchen/Kitchen%20Catalogue-2.jpg?updatedAt=1691465560431",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Kitchen/Kitchen%20Catalogue-3.jpg?updatedAt=1691465560501",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Kitchen/Kitchen%20Catalogue-4.jpg?updatedAt=1691465560674",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Kitchen/Kitchen%20Catalogue-5.jpg?updatedAt=1691465560641",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Kitchen/Kitchen%20Catalogue-6.jpg?updatedAt=1691465560412",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Kitchen/Kitchen%20Catalogue-7.jpg?updatedAt=1691465560568",
        },
      ],
      title: "Tea Towels, Apron, Glove & Potholder",
    },
    {
      imageset: [
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Living/Living%20Catalogue-1.jpg?updatedAt=1691465560550",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Living/Living%20Catalogue-2.jpg?updatedAt=1691465564309",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Living/Living%20Catalogue-3.jpg?updatedAt=1691465564273",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Living/Living%20Catalogue-4.jpg?updatedAt=1691465564322",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Living/Living%20Catalogue-5.jpg?updatedAt=1691465564298",
        },
      ],
      title: "Cushion, Chairpad & Throw",
    },
    {
      imageset: [
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Outdoor/Outdoor%20Catalogue-01.jpg?updatedAt=1691465564393",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Outdoor/Outdoor%20Catalogue-02.jpg?updatedAt=1691465564424",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Outdoor/Outdoor%20Catalogue-03.jpg?updatedAt=1691465564501",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Outdoor/Outdoor%20Catalogue-04.jpg?updatedAt=1691465564773",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Outdoor/Outdoor%20Catalogue-05.jpg?updatedAt=1691465564580",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Outdoor/Outdoor%20Catalogue-06.jpg?updatedAt=1691465564508",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Outdoor/Outdoor%20Catalogue-07.jpg?updatedAt=1691465568022",
        },
      ],
      title: "Chair Pads, Beach Towels & Futon",
    },
    {
      imageset: [
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Bags/Bag%20Catalogue-1.jpg?updatedAt=1691465556526",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Bags/Bag%20Catalogue-2.jpg?updatedAt=1691465556457",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Bags/Bag%20Catalogue-3.jpg?updatedAt=1691465556412",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Bags/Bag%20Catalogue-4.jpg?updatedAt=1691465556448",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Bags/Bag%20Catalogue-5.jpg?updatedAt=1691465556530",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Bags/Bag%20Catalogue-6.jpg?updatedAt=1691465557115",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Bags/Bag%20Catalogue-7.jpg?updatedAt=1691465556352",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Bags/Bag%20Catalogue-8.jpg?updatedAt=1691465560421",
        },
        {
          src: "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Bags/Bag%20Catalogue-9.jpg?updatedAt=1691465560418",
        },
      ],
      title: "Tote Bags, Pouches  & Fruit Bags",
    },
  ]